import { Container } from "react-bootstrap";
import CustomRadio from "../../components/CustomRadio";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as PageRoutes from "./../../utils/route_pages";
import { useEffect, useState } from "react";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "./../../utils/svg_assets";
import { InformationDialog } from "../../components/DialogCollection";

const ReportList = (props) => {
  const { getReport, postReport, reports } = props;
  const navigate = useNavigate();

  const search = useLocation().search;
  const id = new URLSearchParams(search).get("id");
  const type = new URLSearchParams(search).get("type");
  const isAnonymous = new URLSearchParams(search).get("isAnonymous");

  const [payload, setPayload] = useState({
    report: "It’s a spam",
    reason_type: 1,
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getReport();
  }, []);

  const onSubmit = () => {
    const bodyRequest = {
      ...payload,
      object_id: id,
      content_type: type,
      is_anonymous: isAnonymous,
    };

    if (!payload.reason_type) {
      toast.error("Please select report!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }

    if (!payload.report) {
      toast.error("Please input reason first", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }

    postReport(bodyRequest)
      .then((response) => {
        if (response.status === 200) {
          setIsOpen(true);
        }
      })
      .catch(() => {
        toast.error("Kesalahan pada sistem", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  return (
    <div>
      <TopNavigation
        titlePage="Report"
        setBorder={true}
        iconLeft={Assets.iconBack}
        onClick={() => {
          navigate(-1);
        }}
      />
      <Container className="mt-3 px-4">
        <div className="mb-3 fs-14">Why are you reporting this post?</div>
        {reports &&
          reports.map((data, index) => {
            return (
              <CustomRadio
                data={data}
                key={index}
                label={data.reason}
                selected={payload.reason_type}
                onSelected={(value) => {
                  setPayload({
                    ...payload,
                    reason_type: value.id,
                    report: value.reason === "Others" ? null : value.reason,
                  });
                }}
              />
            );
          })}

        {payload.reason_type && payload.reason_type === 8 ? (
          <div>
            <textarea
              placeholder="Help us understand the problem"
              className="border-bottom-outline w-100 fs-12"
              rows="6"
              cols="38"
              maxLength="160"
              onChange={(e) => {
                setPayload({ ...payload, report: e.target.value });
              }}
            />
            <div className="fs-10">max. 160 characters</div>
          </div>
        ) : (
          ""
        )}

        <div className="btn-bottom">
          <Button className="btn-danger fs-14" onClick={() => onSubmit()}>
            Send Report
          </Button>
        </div>

        <InformationDialog
          title="Report Sent"
          style={{ width: "300px" }}
          message="Thank you, admin will review your report shortly."
          closeLabel="Done"
          show={isOpen}
          onHide={() => {
            if (type === "feed") {
              navigate(PageRoutes.home);
            } else {
              navigate(-1);
            }
          }}
        />
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  reports: state.CommonSM.reports,
});

const mapDispatchToProps = (dispatch) => ({
  getReport: dispatch.CommonSM.getReport,
  postReport: dispatch.CommonSM.postReport,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);
